var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal",
      attrs: {
        printButton: "",
        downloadButton: "",
        close: _vm.closeModal,
        printStyle: _vm.printStyle,
        title: _vm.title,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "modal__header",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-sitemap" }),
          _vm._v("\n    Филиалы и представительства\n"),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "htmlContent",
          staticClass: "modal__body",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _c("branches-table", {
            attrs: { inModal: "", type: _vm.type, list: _vm.list },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }